export default __webpack_public_path__ + "static/media/exams_logo.49cd1ddd.png";